import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IChangeStatusRequest } from '../models/models'

export class ChangeStatusApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authSeller/ChangeAuthSeller',
      requesterInfo,
    })
  }

  public async ChangeStatus(req: IChangeStatusRequest): Promise<boolean> {
    return await this.postAsync<boolean>(req)
  }
}
